import React, {useContext, useEffect} from 'react';

import {makeStyles} from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import {useHistory} from "react-router-dom";
import {PermissionsContext, ErrorContext} from "../utils/constants";

import apiFetch from "../utils/apiUtils";


const useStyles = makeStyles(() => ({
  h1: {
    fontWeight: 500,
    fontSize: '56px',
    lineHeight: '66px',
  },
  addContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%'
  },
}));

export default function AdminUtilsDashboard() {
  const classes = useStyles();
  const history = useHistory();
  const { isAdmin } = useContext(PermissionsContext);
  const { triggerError } = useContext(ErrorContext);

  useEffect(() => {
    document.title = 'Rise by TransAlta Admin Utilities';
  }, []);

  if (!isAdmin) {
    history.push('/ui/errors/error404');
  }

  const handleNetCashUpdate = () => {
    apiFetch('/initiatives/updateNetCash', 'POST',
      JSON.stringify({}),
      (results) => {
        console.log('done')
      }, () => () => triggerError({
        title: 'Communication Error',
        description: `We were unable to update the net cash`,
        onRetry: () => handleNetCashUpdate(),
      }));
  };

  const updateAllSapData = () => {
    apiFetch('/sap/updateAllSapData', 'POST',
      JSON.stringify({}),
      (results) => {
        console.log('done')
      }, () => () => triggerError({
        title: 'Communication Error',
        description: `We were unable to start the update of SAP data`,
        onRetry: () => handleNetCashUpdate(),
      }));
  };

  return (
    <main>
      <h1 className={classes.h1}>Utilities</h1>
      <div className={classes.addContainer} >
        <div className={classes.addContainer} >
          <Button
            className={classes.btnStyle}
            variant="contained"
            onClick={handleNetCashUpdate}
          >
            UPDATE ALL INITIATIVES CALCULATED NET CASH
          </Button>
        </div>
        <div className={classes.addContainer} >
          <Button
            className={classes.btnStyle}
            variant="contained"
            onClick={updateAllSapData}
          >
            UPDATE ALL CASH FLOW VALUES WITH SAP DATA
          </Button>
        </div>
      </div>
    </main>
  );
}
